module.exports = __webpack_public_path__ + "img/amx-11.4c03fb42.jpg";